import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, shareReplay } from 'rxjs';

export interface InvitationLookupPayload {
  captchaToken: string;
  requestId: string;
  invitationId: string;
}

@Injectable({
  providedIn: 'root',
})
export class Registerationservice {
  private readonly baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  invitationRegister(body: any) {
    return this.http.post(`${this.baseUrl}/invitation`, body)
  }

  getInvitation(payload: InvitationLookupPayload): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/invitation`, payload);
  }

  createUser(url: string, body: any) {
    return this.http.post(`${this.baseUrl}${url}`, body);
  }
  
  getSalutations(): Observable<any[]> {
    return this.http
      .get<any[]>(`${this.baseUrl}api/master/salutations`)
      .pipe(shareReplay(1));
  }

  getCountries(): Observable<any[]> {
    return this.http
      .get<any[]>(`${this.baseUrl}/lookup/country`)
      .pipe(shareReplay(1));
  }

  getLanguages(): Observable<any[]> {
    return this.http
      .get<any[]>(`${this.baseUrl}api/master/languages`)
      .pipe(shareReplay(1));
  }

}
